import { useEffect, useState } from "react";
import { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

const ROLE_SUFFIX: Record<string, string> = {
  "Director": "project_director",
  "Manager": "project_manager",
  "Team Lead": "team_lead",
  "Team Member": "team_member",
  "Team member": "team_member",
};

export const useScheduleExportAccess = (user: User | null) => {
  const [canExportMSProject, setCanExportMSProject] = useState(true);
  const [canExportPrimavera, setCanExportPrimavera] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const { data: userRow } = await supabase
          .from("users")
          .select("role, company_name")
          .eq("email", user.email)
          .maybeSingle();

        const suffix = userRow?.role ? ROLE_SUFFIX[userRow.role] : undefined;
        const companyName = userRow?.company_name ?? null;

        if (!suffix || !companyName) {
          setCanExportMSProject(true);
          setCanExportPrimavera(true);
          return;
        }

        const msCol = `sm_export_msproject__${suffix}`;
        const prCol = `sm_export_primavera__${suffix}`;

        const { data: permRow } = await supabase
          .from("project_access_permissions")
          .select(`${msCol}, ${prCol}`)
          .eq("company_name", companyName)
          .maybeSingle();

        if (!permRow) {
          setCanExportMSProject(true);
          setCanExportPrimavera(true);
          return;
        }

        const rec = permRow as unknown as Record<string, unknown>;
        setCanExportMSProject(rec[msCol] !== false);
        setCanExportPrimavera(rec[prCol] !== false);
      } catch (e) {
        console.error("useScheduleExportAccess error", e);
        setCanExportMSProject(true);
        setCanExportPrimavera(true);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [user?.email]);

  return { canExportMSProject, canExportPrimavera, loading };
};
